import createSlateEditList from '@guestbell/slate-edit-list';
import createBasePlugin from './createBasePlugin';
export default (function (defaultDefinition) { return function (customize) {
    var def = customize ? customize(defaultDefinition) : defaultDefinition;
    var slateEditList = createSlateEditList({
        typeItem: def.listItemType,
        types: def.listTypes,
    });
    return [
        createBasePlugin({
            pluginType: 'custom',
            addToolbarButton: true,
            addHoverButton: false,
            icon: def.iconIncrease,
            customAdd: function (editor) {
                slateEditList.changes.increaseItemDepth(editor);
            },
            customRemove: function (editor) {
                slateEditList.changes.decreaseItemDepth(editor);
            },
            isDisabled: function (editor) {
                var editorState = editor.value;
                var previousItem = slateEditList.utils.getPreviousItem(editorState);
                var currentItem = slateEditList.utils.getCurrentItem(editorState);
                var canIncrease = Boolean(previousItem && currentItem);
                return !canIncrease;
            },
        }),
        createBasePlugin({
            pluginType: 'custom',
            addToolbarButton: true,
            addHoverButton: false,
            icon: def.iconDecrease,
            customAdd: function (editor) {
                slateEditList.changes.decreaseItemDepth(editor);
            },
            customRemove: function (editor) {
                slateEditList.changes.increaseItemDepth(editor);
            },
            isDisabled: function (editor) {
                var editorState = editor.value;
                var currentItem = slateEditList.utils.getCurrentItem(editorState);
                var itemDepth = slateEditList.utils.getItemDepth(editorState);
                var canDecrease = Boolean(itemDepth > 1 && currentItem);
                return !canDecrease;
            },
        }),
    ];
}; });
//# sourceMappingURL=createListIndentionPlugin.js.map